<div class="container" *ngIf="{
      itemData: itemData$ | async,
      itemFields: itemFields$ | async
    } as async">
  <button class="btn-empty close" (click)="close()">
    <svg [icon]="icons.Close" class="dark-gray-color svg24" />
  </button>

  <app-loader *ngIf="loading"></app-loader>
  <app-catalog-item-card-info *ngIf="!loading" [headTitle]="title" [title]="titleInner" [showAllFields]="false" [itemFields]="async.itemFields" [itemData]="async.itemData"></app-catalog-item-card-info>
</div>
